import { ApplyModalProvider } from '../../features/apply/apply-context';
import { Header } from '../header/header';
import { Footer } from '../footer/footer';
import type { ReactNode } from 'react';

/** Each page owns its shell, preserving the existing page-scoped form lifecycle. */
export function PublicPageShell({ children }: { children: ReactNode }) {
  return (
    <ApplyModalProvider>
      <Header />
      <main className="flex flex-col gap-16 py-8 sm:gap-20 sm:py-12 lg:gap-24">{children}</main>
      <Footer />
    </ApplyModalProvider>
  );
}
